import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recruiter',
  templateUrl: './recruiter.component.html',
  styleUrls: ['./recruiter.component.scss']
})
export class RecruiterComponent implements OnInit {
  logos:string[]=[
    '/assets/img/recruiter/1.jpg',
    '/assets/img/recruiter/2.jpg',
    '/assets/img/recruiter/3.jpg',
    '/assets/img/recruiter/4.jpg',
    '/assets/img/recruiter/5.jpg',
    '/assets/img/recruiter/6.jpg',
    '/assets/img/recruiter/7.jpg',
    '/assets/img/recruiter/8.jpg',
    '/assets/img/recruiter/9.jpg',
    '/assets/img/recruiter/10.jpg',
    '/assets/img/recruiter/11.jpg',
    '/assets/img/recruiter/12.jpg',
    '/assets/img/recruiter/13.jpg',
    '/assets/img/recruiter/14.jpg',
    '/assets/img/recruiter/15.jpg',
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
